module.exports = __webpack_public_path__ + "ff1ee74b.svg";